/**
 * Safe base64 encoding function that handles Unicode characters
 * @param str - The string to encode
 * @returns Base64 encoded string
 */
export const safeBase64Encode = (str: string): string => {
  try {
    // First try the standard btoa
    return btoa(str)
  } catch (error) {
    // If btoa fails due to Unicode characters, use a safe approach
    const encoder = new TextEncoder()
    const bytes = encoder.encode(str)
    const binaryString = Array.from(bytes, byte => String.fromCharCode(byte)).join('')
    return btoa(binaryString)
  }
}

/**
 * Safe base64 decoding function
 * @param str - The base64 string to decode
 * @returns Decoded string
 */
export const safeBase64Decode = (str: string): string => {
  try {
    // First try the standard atob
    return atob(str)
  } catch (error) {
    // If atob fails, use a safe approach
    const binaryString = atob(str)
    const bytes = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    const decoder = new TextDecoder()
    return decoder.decode(bytes)
  }
}
